// Theme management — persists user choice in localStorage
const THEME_KEY = "credit_app_theme";
export const THEMES = [
    {
        key: "default",
        label: "ΠΡΟΕΠΙΛΟΓΗ",
        description: "Industrial · IBM Plex Sans · γωνίες 0",
        swatches: ["#FAFAFA", "#0A0A0A", "#002FA7", "#FF3B30"],
    },
    {
        key: "dark",
        label: "ΣΚΟΥΡΟ",
        description: "Modern · Inter · στρογγυλεμένο",
        swatches: ["#0F1115", "#1A1D24", "#5DA0FF", "#5DD183"],
    },
    {
        key: "colorful",
        label: "ΠΟΛΥΧΡΩΜΟ",
        description: "Playful · Poppins bold · πολύ στρογγυλό",
        swatches: ["#FFF6E5", "#4B0082", "#E91E63", "#FF9500"],
    },
    {
        key: "serious",
        label: "ΣΟΒΑΡΟ",
        description: "Classic · Serif · διακριτικά στρογγυλό",
        swatches: ["#F5F2EC", "#1A2238", "#8B2530", "#4A6741"],
    },
];

export function getStoredTheme() {
    try {
        return localStorage.getItem(THEME_KEY) || "default";
    } catch {
        return "default";
    }
}

export function applyTheme(key) {
    const root = document.documentElement;
    if (!key || key === "default") {
        delete root.dataset.theme;
    } else {
        root.dataset.theme = key;
    }
    try {
        localStorage.setItem(THEME_KEY, key || "default");
    } catch {
        // ignore
    }
}

// Apply theme on module load (before React hydrates)
applyTheme(getStoredTheme());
